import React from 'react';

import MainTemplate from 'pages/templates/MainTemplate';

const NativeRTB = () => {
  return (
    <MainTemplate>
      <h2>네이티브 RTB</h2>
    </MainTemplate>
  );
};

export default NativeRTB;
